import React, { PureComponent } from 'react';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class RetencionesLocalesForm extends PureComponent {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      ImpLocRetenido: ['required', 'string', 'min:1'],
      TasadeRetencion: ['required', 'decimal:2'],
      Importe: ['required', 'decimal:2'],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.data && !!this.props.data && !!this.props.data.id && !this.state.data.id) {
      this.handleOnChange({
        ...this.props.data,
      });
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  };

  handleOnAdd = () => {
    const { data } = this.state;

    const newData = {
      ...data,
    };

    this.props.onAdd(newData);

    this.setState({
      data: {},
      isValid: false,
    });

    this.validate({});
  };

  render() {
    const { data, isValid } = this.state;
    const rules = this.rules;

    return (
      <>
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Nombre Impuesto Local Retenido"
              name="ImpLocRetenido"
              placeholder=""
              help=""
              rules={rules.ImpLocRetenido}
              value={data.ImpLocRetenido}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Tasa de Retencion"
              name="TasadeRetencion"
              rules={rules.TasadeRetencion}
              value={data.TasadeRetencion}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Importe"
              name="Importe"
              placeholder=""
              help=""
              rules={rules.Importe}
              value={data.Importe}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar retencion local
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default RetencionesLocalesForm;
